import _ from 'lodash'
import { createOptionCategoryItem, updateOptionCategoryItem } from '../../apis/backend'
import { isStringNotNull, keyGenerator, removeUndefinedProperties, isValidFrenchDecimalInput } from '../../utils/tools'
import {
  ERROR_SYNCHRONIZATION_WITH_SHOP,
  ERROR_UPDATE_OPTION,
  ERROR_WRONG_INFORMATIONS,
  EXTRA,
  MENU,
  PRODUCT,
  SPLASH, ERROR_PRICE, ERROR_OPTION_PRICE
} from '../../constants'
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration'

export const autocompleteChangeInput = (value, component) => {
  component.setState(prevState => {
    const { option } = prevState;
    return { option: { ...option, productKey: value } };
  });
};
export const handleChangeInput = ({ target }, component, isPriceInput = false) => {
  const rawValue = target.value;

  let value;
  if (isPriceInput) {
    const normalized = rawValue.replace('.', ',');
    if (!isValidFrenchDecimalInput(normalized)) {
      return;
    }

    const { option: stateOption } = component.state;
    const currentPriceRef = stateOption.priceRef;
    const { shopId } = component.props;

    let numericValue = parseFloat(normalized.replace(',', '.'));
    if (isNaN(numericValue)) numericValue = 0;

    if (hasExternalIntegration(shopId) === SPLASH && currentPriceRef > 0 && numericValue > currentPriceRef) {
      value = String(currentPriceRef).replace('.', ',');
    } else {
      value = normalized;
    }

  } else {
    value = rawValue;
  }

  component.setState(prevState => {
    const { option } = prevState;
    return { option: { ...option, [target.id]: value } };
  });
};

export const handleUpdateOption = async (component, shopsMenu) => {
  const { openErrorModal, category, closeModal, createOption, shopId } = component.props;
  const { items = {}, type, key: optionKey } = category;
  const hasMenuPOS = checkIntegrationAccess('products', 'hasMenuPOS')
  try {
    component.setState({ isLoading: true });
    const { option, categoriesArray, synchronize } = component.state;
    const maxPosition = _.maxBy(_.map(items), elt => elt.position);
    const {
      name,
      position: rawPosition = maxPosition ? maxPosition.position + 1 : 0,
      price = 0,
      ref = '',
      productKey
    } = option;    
    const priceString = String(price).replace(',', '.');
    const parsedPrice = parseFloat(priceString);
    const safePrice = Number.isNaN(parsedPrice) || parsedPrice < 0 ? 0 : parsedPrice;
    const position = Math.max(0, rawPosition);
    let categories = '';
    categoriesArray.forEach(category => {
      const { key } = category;
      categories += `${categories === '' ? '' : ','}${key.includes(',') ? key.split(',')[0] : key
        }`;
    });
    const nameToCkeck = name ? name.replace(/\s+/g, '') : '';
    if (hasExternalIntegration(shopId) === SPLASH && safePrice > option?.priceRef) {
      openErrorModal(`${ERROR_PRICE} ${option?.priceRef} €`)
      return;
    }
    if (
      nameToCkeck &&
      nameToCkeck.length > 0 &&
      safePrice >= 0 &&
      (isStringNotNull(ref) || !hasExternalIntegration())
    ) {
      const newItem = removeUndefinedProperties({
        name,
        position,
        price: safePrice,
        priceRef: hasExternalIntegration(shopId) === SPLASH ? safePrice : null,
        additional: category.additional || null,
        ref,
        key: createOption ? keyGenerator('ITEM') : option.key,
        posProperties: option?.posProperties,
        subcategories: categories,
        type: hasMenuPOS ? type : null,
        productKey
      })
      if (!synchronize || (synchronize && _.size(shopsMenu) > 1)) {
        if (createOption) {
          await createOptionCategoryItem(optionKey, newItem, Object.keys(shopsMenu || {}));
        } else {
          await updateOptionCategoryItem(optionKey, newItem, Object.keys(shopsMenu || {}));
        }
        closeModal(component);
        component.setState({ showModal: false, synchronize: false });
      }
      else {
        openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP); component.setState({ isLoading: false })
      }

    } else openErrorModal(ERROR_WRONG_INFORMATIONS);
  } catch (error) {

    const errorMessage = error?.message || '';

    if (errorMessage.includes('could not exceed 0')) {
      openErrorModal(ERROR_OPTION_PRICE);
    } else {
      openErrorModal(ERROR_UPDATE_OPTION);
    }
  }

  component.setState({ isLoading: false });
};
export const addSubCategory = (categoriesArray, key, itemIndex, component) => {
  const { categories } = component.props;
  component.setState(() => {
    if (itemIndex > -1) categoriesArray.splice(itemIndex, 1);
    else
      categoriesArray.push({
        name: categories[key].name,
        key
      });
    return { categoriesArray };
  });
};
export const getFiltredCategories = (categories, type, ref) => {
  if (type === MENU) {
    return _.pickBy(categories, category => category.type !== EXTRA)
  }
  else if (ref === '$') {
    return _.pickBy(categories, category => category.type === PRODUCT)
  }
  return categories
}

export const getFiltredSections = (sectionsPos, productType) => {
  const newSections = {}
  _.map(sectionsPos, (section, sectionKey) => {
    const newProducts = {}
    _.map(section?.products, (product, key) => {
      if (product.type === productType) {
        newProducts[key] = product
        section.products = newProducts
        _.assign(newSections, { [sectionKey]: section })
      }
    })
  })
  return newSections

}
export const getSplashIngredientsFromCategory = (category, categoriesPOS) => {
  let ingredientCategory = _.pick(categoriesPOS, [category.key]);
  if (_.isEmpty(ingredientCategory) && category.items) {
    const firstItemRef = _.values(category.items)[0]?.ref;
    _.map(categoriesPOS, posCategory => {
      _.map(posCategory?.items, item => {
        if (item.ref === firstItemRef) {
          ingredientCategory = _.pick(categoriesPOS, [posCategory.key]);
        }
      })
    }
    );
  }

  return ingredientCategory;
};
